var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cs-course-name-cell"},[_c('div',[_c('i',{staticClass:"fa fa-folder fa-3 color-blue",attrs:{"aria-hidden":"true"},on:{"click":_vm.onClick}}),_vm._v(" "),_c('span',{staticClass:"cs-course-name",on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.name))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7608bb5b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/paginationCells/coursewareNameCell.vue
// module id = tOx6
// module chunks = 0